<template>
  <div>
    <ts-dialog
      :title="`Edit a ${group == 'delivery' ? 'Delivery ' : ''} file request`"
      :visible.sync="visible"
      width="500px"
      center
      :show-close="false"
    >
      <div>
        <ts-form-item label="Title of the file request" :validation="$v.form.name">
          <ts-input placeholder="" v-model.lazy="$v.form.name.$model"></ts-input>
        </ts-form-item>
        <ts-form-item label="Description of the file request (optional)" :validation="$v.form.description">
          <ts-input type="textarea" :rows="4" placeholder="" v-model.lazy="$v.form.description.$model"></ts-input>
        </ts-form-item>
        <ts-form-item
          v-if="group == 'delivery'"
          label="Select a plateform for the received assets (optional) "
          :validation="$v.form.platforms"
          class="dropdown"
        >
          <MultiSelectionDropdown
            placeholder="Select platforms"
            :width="378"
            size="large"
            :options="platforms"
            v-model.lazy="$v.form.platforms.$model"
          >
          </MultiSelectionDropdown>
        </ts-form-item>
      </div>
      <span slot="footer">
        <div class="footer">
          <ts-button @click="handleSaveClick">Save</ts-button>
        </div>
      </span>
    </ts-dialog>
    <ts-button size="small" circle @click="handleOpenDialogButtonClick">
      <ts-icon icon="pen" size="x-small" color="#6d7587" title="Edit" />
    </ts-button>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';
export default {
  components: { MultiSelectionDropdown },
  props: {
    value: {
      type: Object,
      required: true
    },
    group: {
      type: String,
      default: 'assets'
    }
  },
  computed: {
    ...mapState('workflow', {
      platforms: state => state.myProjects.options.platforms
    })
  },
  data() {
    return {
      visible: false,
      form: cloneDeep(this.value)
    };
  },
  validations: {
    form: {
      name: {
        required
      },
      platforms: {},
      description: {}
    }
  },
  methods: {
    handleOpenDialogButtonClick() {
      this.form = cloneDeep(this.value);
      this.visible = true;
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', this.form);
        this.visible = false;
      }
    }
  }
};
</script>

<style>
</style>